export const createDataFiles = (form) => {
    if ('image' in form) {
        const formdata = new FormData()
        const entries = Object.entries(form)
        entries.some(([key, value]) =>
            formdata.append(key, value)
        )
        return (formdata)
    }
    return form
}

export function capitalize(string) {
    if (string.length === 0) return
    return string[0].toUpperCase() + string.slice(1);
}
export const formatCurrency = (value, lng = 'pt-BR', currency = 'BRL') => {

    let moneyValue = value

    if (moneyValue === null) {
        moneyValue = 0
    }

    if (moneyValue === undefined) {
        moneyValue = 0
    }

    const moneyFormated = new Intl.NumberFormat(lng, {
        style: 'currency',
        currency: currency
    }).format(moneyValue)
    return moneyFormated
}

export const formatDate = (dateStr) => {
    return dateStr.split("-").reverse().join("/");
};

export const convertDateFormat = (dateString) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const date = new Date(dateString);

        const formattedDate = date.toISOString().slice(0, 10);

        return formattedDate;
    } else {
        const date = new Date(dateString);

        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        return formattedDate;
    }
}
